import { FC, ReactNode } from "react";
import { Typography } from "../../core/Typography/Typography";
import {
  TypographyColor,
  TypographyVariant,
} from "../../../constants/typography";
import { useStyles } from "./SettingRow.style";

interface ISettingRowProps {
  title: string;
  description: string;
  control: ReactNode;
}

export const SettingRow: FC<ISettingRowProps> = ({
  title,
  description,
  control,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.text}>
        <Typography variant={TypographyVariant.BodyB5Bold}>{title}</Typography>
        <Typography
          variant={TypographyVariant.BodyB6Regular}
          color={TypographyColor.Silver}
        >
          {description}
        </Typography>
      </div>
      <div className={classes.control}>{control}</div>
    </div>
  );
};
